<template>
  <div>
    <v-card class="px-2 py-2">
      <h2 class="mb-3">Changer de mot de passe</h2>
      <v-text-field
        v-model="oldPassword"
        label="Mot de passe actuel"
        type="password"
        v-validate="'required'"
        data-vv-name="actual"
        :error-messages="errors.collect('actual')"
      ></v-text-field>
      <v-text-field
        v-model="newPassword"
        label="Nouveau (minuscules, majuscules et chiffres)"
        type="password"
        ref="new1"
        v-validate="{
          required: true,
          min: 8,
          regex: /^(?=.*[A-z])(?=.*[A-Z])(?=.*[0-9])\S{8,}$/
        }"
        data-vv-name="new1"
        :error-messages="errors.collect('new1')"
      ></v-text-field>
      <v-text-field
        v-model="newPasswordBis"
        label="Confirmez le mot de passe"
        type="password"
        v-validate="'required|confirmed:new1'"
        data-vv-name="new2"
        :error-messages="errors.collect('new2')"
      ></v-text-field>
      <div class="d-flex justify-center">
        <v-btn color="accent" @click="save()">Sauvegarder</v-btn>
      </div>
    </v-card>
    <v-snackbar v-model="showSuccess"> Modifications enregistrées </v-snackbar>
    <v-snackbar v-model="showError"> Une erreur a eu lieu </v-snackbar>
    <v-snackbar v-model="showBadPassword"> Mot de passe invalide </v-snackbar>
  </div>
</template>
<script>
import { fetchHil } from "../../utils";
import moment from "moment";

export default {
  name: "UserPassword",

  data() {
    return {
      oldPassword: "",
      newPassword: "",
      newPasswordBis: "",
      showSuccess: false,
      showError: false,
      showBadPassword: false
    };
  },

  methods: {
    async save() {
      if (!this.$validator.validateAll()) {
        return;
      }
      try {
        const resp = await fetchHil("/user/changePassword", {
          method: "POST",
          body: {
            password: this.newPassword,
            oldPassword: this.oldPassword
          }
        });
        if (!resp.ok) {
          throw new Error("validation failed");
        }
        this.showSuccess = true;
        this.newPassword = "";
        this.newPasswordBis = "";
        this.oldPassword = "";
      } catch (e) {
        console.warn(e);
        this.showError = true;
      }
    }
  }
};
</script>
<style></style>
